export const getDefault = ({ lang }) => {  
  const schema = {
    name: 'SubWebDepartment',
    isLoading: false,
    hasError: false,
    data: {
      title: 'O departamento',
      description:
        'Texto de apresentação do departamento com link para uma página com um texto mais detalhado. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse semper tellus eu massa aliquam euismod. Donec dignissim, leo vel sodales bibendum, nibh justo commodo ante, vitae fermentum turpis quam quis tellus. Phasellus consequat leo eu fermentum euismod. Suspendisse nisl ipsum, condimentum ac maximus id, feugiat eget enim. Phasellus accumsan rutrum enim, viverra maximus ipsum gravida ut. Nunc iaculis mauris libero, vel condimentum arcu vestibulum vitae.',
      link: null,
      imageUrl: 'https://api-assets.ua.pt/files/imgs/000/000/053/original.jpg',
      buttonTitle: lang === 'pt' ? 'saber mais' : 'learn more'
    },
  };
  return schema;
};
